import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import "./IndividualPages.css";
import V1 from '../../assets/videos/BD.mp4'
import V2 from '../../assets/videos/RA.mp4'
import V3 from '../../assets/videos/SC.mp4'
import V4 from '../../assets/videos/PE.mp4'
import V5 from '../../assets/videos/REE.mp4'
import V6 from '../../assets/videos/is.mp4'
import V7 from '../../assets/videos/OCM.mp4'

// PERFECT bullet converter for YOUR JSON format with <br> tags
const convertBulletsToList = (text) => {
  if (!text) return '';

  // Replace <br> with \n and clean up
  let cleanText = text
    .replace(/<br\s*\/?>/gi, '\n')        // Convert <br> to newlines
    .replace(/&bull;|•/g, '• ')           // Ensure proper bullet spacing
    .replace(/\.\s*point/gi, '');         // Remove .point artifacts

  // Split into lines and process bullets
  const lines = cleanText.split('\n').map(line => line.trim()).filter(Boolean);
  
  // Check if this has bullets (more than 1 line with bullet pattern)
  const bulletLines = lines.filter(line => /^•/.test(line));
  
  if (bulletLines.length > 1) {
    const listItems = lines
      .filter(line => /^•/.test(line))      // Only bullet lines
      .map(line => `<li>${line.replace(/^•\s*/, '')}</li>`);
    
    return `<ul>${listItems.join('')}</ul>`;
  }
  
  // Fallback for single lines or regular text
  return `<p>${lines.join(' ')}</p>`;
};

const CompactVideoHero = ({ videos }) => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (!videos || videos.length === 0) return;
    const t = setInterval(() => {
      setIndex((i) => (i + 1) % videos.length);
    }, 4000);
    return () => clearInterval(t);
  }, [videos]);

  if (!videos || videos.length === 0) return null;

  const current = videos[index];

  return (
    <div className="compact-video-hero">
      <video
        src={current.src}
        muted
        loop
        playsInline
        autoPlay
        className="compact-video-player"
      />
      <div className="video-overlay-gradient" />

      <div className="video-nav-dots">
        {videos.map((_, i) => (
          <button
            key={i}
            className={`dot ${i === index ? 'active' : ''}`}
            onClick={() => setIndex(i)}
            aria-label={`Go to video ${i + 1}`}
          />
        ))}
      </div>
    </div>
  );
};

const IndividualPage = () => {
  const { state } = useLocation();
  const productName = state?.productName;
  const [product, setProduct] = useState(null);

  useEffect(() => {
    fetch("/Json/IndividualPages/IndividualPage.json")
      .then((res) => res.json())
      .then((data) => {
        const foundProduct = data.find((item) => item.name === productName);
        setProduct(foundProduct);
      })
      .catch(err => {
        console.error('Error fetching product data:', err);
      });
  }, [productName]);

  if (!product) return <div className="loading-compact">Loading...</div>;

  const defaultVideos = [
    { src: V1 }, { src: V2 }, { src: V3 }, { src: V4 },
    { src: V5 }, { src: V6 }, { src: V7 }
  ];

  const videos = product.heroVideos || defaultVideos;

  // Process each field separately for perfect bullet conversion
  const processedDescription = convertBulletsToList(product.description || '');
  const processedExtraDesc = convertBulletsToList(product.extraDesc || '');
  const processedOutcome = convertBulletsToList(product.outcome || '');

  return (
    <div className="individual-compact-page">
      {/* VIDEO(IMAGE OVERLAY) | CONTENT LAYOUT */}
      <div className="video-content-hero">
        {/* VIDEO WITH OVERLAPPING IMAGE */}
        <div className="video-with-image-column">
          <CompactVideoHero videos={videos} />
          <div className="overlapping-image-container">
            <img
              src={product.images}
              alt={product.name}
              className="overlapping-product-image"
            />
          </div>
        </div>

        {/* CONTENT */}
        <div className="content-column">
          <div className="content-compact-inner">
            <h1 className="compact-title-main">{product.name}</h1>
            {product.title && (
              <h2 className="compact-title-sub">{product.title}</h2>
            )}
            <div
              className="compact-content"
              dangerouslySetInnerHTML={{
                __html: `${processedDescription}${processedExtraDesc}${processedOutcome}`
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default IndividualPage;
